exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".assessment-card.clickable{cursor:pointer}.assessment-card h3.h3-no-title{height:30px;font-size:20px;margin-bottom:10px}.assessment-card .img-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.assessment-card .img-container img{float:left;padding-right:20px;height:80%;width:30%}.assessment-card .img-container .description{border-left:1px solid #d9dbdc;font-size:16px;font-weight:200;color:grey;padding-left:20px;padding-top:15px;padding-bottom:15px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/scss/component/assessments/custom-cards.scss
// module id = 3659
// module chunks = 3